import DrawingActions from '../actions/DrawingActions';
import storeManager from '../store/StoreManager';
import { t } from './i18nService';
import marketplacePropertiesService from './MarketplacePropertiesService';

const DrawingService = {
    getInProgressDrawingForItem(contentRevisionId, inProgressDrawings) {
        return inProgressDrawings.find(drawing => drawing.contentRevisionId === contentRevisionId);
    },

    updateInProgressDrawings(contentRevisionId, drawing) {
        storeManager.dispatch(DrawingActions.updateInProgressDrawings(contentRevisionId, drawing));
    },

    removeInProgressDrawing(contentRevisionId) {
        storeManager.dispatch(DrawingActions.removeInProgressDrawing(contentRevisionId));
    },

    filterOutInProgressDrawingsById(contentRevisionId, inProgressDrawings) {
        return inProgressDrawings.filter(drawing => drawing.contentRevisionId !== contentRevisionId);
    },

    isCollapsibleDrawingModalEnabled() {
        return marketplacePropertiesService.isCollapsibleDrawingModalEnabled();
    },

    /*
     * IF the collapsible mpp is enabled
     * AND there is a drawing started for this question
     * AND the modal is currently not expanded
     * then return `shouldShowCollapsedView: true`
     * so that the collapsed box can be rendered
     */
    shouldShowCollapsedView(hasDraftedDrawing, isExpanded) {
        return this.isCollapsibleDrawingModalEnabled()
          && hasDraftedDrawing
          && !isExpanded;
    },

    /*
     * IF the user clicked to "start new drawing"
     * OR they clicked the expand button in the collapsed box
     * then return `shouldShowExpandedView: true`
     * so that the expanded drawing modal can be rendered
     */
    shouldShowExpandedView(isExpanded, isDrawingToolClicked) {
        return isExpanded
          || isDrawingToolClicked;
    },

    getModalId(ckeditor) {
        const ckEditorName = ckeditor?.name;

        if (ckEditorName) {
            return `${ckEditorName}_drawingModal`;
        }

        return 'untitled_drawingModal';
    },

    getModalTitle(questionTitle, questionNr) {
        const title = questionTitle || '';
        const number = questionNr || '';

        const fullTitle = `${number} ${title}`.trim();
        return fullTitle || t('essay.drawing.untitled');
    },

    setDrawingIconsPosition(target, iconsWrapper) {
        const minLeftOffset = 16;
        const imgWidth = target.getSize('width');
        const imgOffsetTop = target.$.offsetTop;
        const imgOffsetLeft = target.$.offsetLeft;
        const left = Math.max((imgOffsetLeft + imgWidth) - iconsWrapper.clientWidth - 6, minLeftOffset);

        iconsWrapper.style.top = `${imgOffsetTop + iconsWrapper.clientHeight}px`;
        iconsWrapper.style.left = `${left}px`;
    },
};

export default DrawingService;
